import useAddress from '@/containers/SubscriptionFormPageNew/Components/Address/useAddress'
import { FormControl } from 'baseui/form-control'
import getError from '@/containers/SubscriptionFormPage/getError'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'

const StreetName = () => {
  const { t, updateAddress, errors, streetNumber, streetName, city, showAddressFields } = useAddress()

  if (!showAddressFields) {
    return null
  }

  return (
    <FormControl error={getError('streetName', errors)}>
      <SDInput
        label={t('subscriptionForm:address_module.street_name')}
        onBlur={streetName =>
          updateAddress({ streetName, label: (streetNumber ?? '') + ' ' + (streetName ?? '') + ' ' + (city ?? '') })
        }
        currentValue={streetName}
      />
    </FormControl>
  )
}

export default StreetName
